import { useProjectPermissions } from 'hooks/useProjectPermissions'
import LinkSection from '../LinkSection'
import WikiForm from './components/WikiForm'
import WikiLink from './components/WikiLink'

const Wiki = () => {
  const { projectInfo } = useProjectPermissions()

  const wikiLink = projectInfo?.wiki_link ?? ''
  const hasWikiLink = !!wikiLink

  return (
    <LinkSection
      hasLink={hasWikiLink}
      addTitle="Добавить"
      editTitle="Редактировать"
      renderPublished={() => <WikiLink link={wikiLink} />}
      emptyText={'Страница проекта ещё не опубликована'}
      renderForm={({ onCancel }) => (
        <WikiForm link={wikiLink} onCancel={onCancel} />
      )}
    />
  )
}

export default Wiki
